import React from 'react';
import classNames from "classnames";
import {observer} from "mobx-react-lite"
import {ValidationRuleNames} from "common/validation/rules/ValidationRule";
import useUIValidator from "common/validation/component/UseUIValidator";
import {ValidationRuleBytesProps} from "common/validation/rules/ValidationRuleBytes";
import {usePasswordDispatch} from 'common/hooks/PasswordContext';

export interface UIInputPWProps {
    autoFocus?: boolean;
    setFocus?: boolean;
    full?: boolean;
    className?: string;
    placeholder?: string;
    attrs?: React.InputHTMLAttributes<HTMLInputElement>;
    onKeyEnter?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    readOnly?: boolean;
    disabled?: boolean;
    valueChanged?: (value: any) => void;
    minLength?: number;
    maxLength?: number;
    rules?: Array<ValidationRuleNames>;
    bytes?: ValidationRuleBytesProps;
    focusClear?: boolean;

    isOnCapsLock?(result: boolean): void;
}

function UIInputPW({
                       autoFocus,
                       setFocus,
                       full,
                       className,
                       placeholder = "비밀번호를 입력하세요",
                       attrs = {},
                       onKeyEnter,
                       readOnly,
                       disabled,
                       valueChanged,
                       minLength,
                       maxLength,
                       rules = [],
                       bytes,
                       focusClear,
                       isOnCapsLock
                   }: UIInputPWProps) {
    const orgPlaceholder = placeholder;
    const [placeholderStr, setPlaceholderStr] = React.useState(placeholder)

    const passwordInputElement = React.useRef<HTMLInputElement>(null);
    const [passwordInput, setPasswordInput] = React.useState("");
    const {required, valueChecker, errorClassName, setElement} = useUIValidator({rules: rules, bytes: bytes})
    const dispatch = usePasswordDispatch();
    React.useEffect(() => {
        dispatch(true)
    })
    React.useEffect(() => {
        if (setFocus) {
            passwordInputElement.current?.focus();
        }
    }, [setFocus]);

    React.useEffect(() => {
        valueChecker.setValue(passwordInput);
    }, [passwordInput]);

    React.useEffect(() => {
        setElement(passwordInputElement?.current);
    }, [passwordInputElement])

    return (
        <input
            //ref={(element) => setFocus === true && element?.focus()}
            ref={passwordInputElement}
            type='password'
            className={classNames(className)}
            placeholder={placeholderStr}
            readOnly={readOnly}
            disabled={disabled}
            maxLength={maxLength}
            minLength={minLength}
            autoFocus={autoFocus}
            data-enc="on"
            {...attrs}
            onKeyDown={event => {
                if (event.getModifierState("CapsLock")) {
                    isOnCapsLock ? isOnCapsLock(true) : setPlaceholderStr("Caps Lock이 켜져있습니다.");
                } else {
                    isOnCapsLock ? isOnCapsLock(false) : setPlaceholderStr(orgPlaceholder);
                }
            }}
            onKeyUp={event => {
                setPasswordInput(event.currentTarget.value)
                if (valueChanged && event.key !== "Enter") {
                    valueChanged(event.currentTarget.value);
                }
                if (onKeyEnter && event.key === "Enter") {
                    onKeyEnter(event);
                }
            }}
            onFocus={event => {
                if (focusClear) {
                    window["focusDataClear"](event.target)
                }
            }}
            autoComplete={"new-password"}
            aria-autocomplete={"none"}
            required={required}
            data-value-rule={rules}
            data-value-bytes={JSON.stringify(bytes || {})}
            data-validation-message={valueChecker.message}
        />
    );
}

export default observer(UIInputPW);
